import { render, staticRenderFns } from "./CheckoutOrderSummary.vue?vue&type=template&id=d129cff8&"
import script from "./CheckoutOrderSummary.vue?vue&type=script&lang=js&"
export * from "./CheckoutOrderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports